// Configuración de debugging
export const DEBUG_CONFIG = {
  ENABLE_LOGS: true, // Cambiar a false para desactivar todos los logs
  ENABLE_AUTH_LOGS: true,
  ENABLE_HTTP_LOGS: true,
  ENABLE_COMPONENT_LOGS: true
};

// Helper function para logs condicionales
export const debugLog = (category, ...args) => {
  if (!DEBUG_CONFIG.ENABLE_LOGS) return;
  
  switch (category) {
    case 'auth':
      if (DEBUG_CONFIG.ENABLE_AUTH_LOGS) console.log(...args);
      break;
    case 'http':
      if (DEBUG_CONFIG.ENABLE_HTTP_LOGS) console.log(...args);
      break;
    case 'component':
      if (DEBUG_CONFIG.ENABLE_COMPONENT_LOGS) console.log(...args);
      break;
    default:
      console.log(...args);
  }
}; 